<div class="mat-elevation-z8 text-center">

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->
      
        <!-- Position Column -->
        <ng-container matColumnDef="pname">
          <th mat-header-cell *matHeaderCellDef> <h5>Plan Name</h5> </th>
          <td mat-cell *matCellDef="let element"> {{element.payload.doc.data().pname}} </td>
        </ng-container>
        
        <ng-container matColumnDef="blank">
          <th mat-header-cell *matHeaderCellDef> <h5>&nbsp;&nbsp;</h5> </th>
          <td mat-cell *matCellDef="let element"> &nbsp;&nbsp; </td>
        </ng-container>
      
        <!-- Name Column -->
        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef> <h5>Price</h5> </th>
          <td mat-cell *matCellDef="let element"> {{element.payload.doc.data().price}} </td>
        </ng-container>
        
        <ng-container matColumnDef="speed">
          <th mat-header-cell *matHeaderCellDef> <h5>Speed</h5> </th>
          <td mat-cell *matCellDef="let element"> {{element.payload.doc.data().speed}} </td>
        </ng-container>
        
        <ng-container matColumnDef="data">
          <th mat-header-cell *matHeaderCellDef> <h5>Data</h5> </th>
          <td mat-cell *matCellDef="let element"> {{element.payload.doc.data().data}} </td>
        </ng-container>
        
        <ng-container matColumnDef="exspeed">
          <th mat-header-cell *matHeaderCellDef> <h5>Ex Speed</h5> </th>
          <td mat-cell *matCellDef="let element"> {{element.payload.doc.data().exspeed}} </td>
        </ng-container>
      
        <!-- Weight Column -->
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef> <h5>Category</h5> </th>
          <td mat-cell *matCellDef="let element"> {{element.payload.doc.data().category}} </td>
        </ng-container>

        
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> <h5>Actions</h5> </th>
            <td mat-cell *matCellDef="let element"> 
                <button class="btn btn-outline-success mat-elevation-z8" (click)="goEdit(element.payload.doc.id)">Edit</button>&nbsp;
                <button class="btn btn-outline-danger mat-elevation-z8" (click)="goDelete(element.payload.doc.id)">Delete</button> 
            </td>
        </ng-container>

        
        <!-- <ng-container matColumnDef="image">
            <th mat-header-cell *matHeaderCellDef> <h5>Plan Image</h5> </th>
            <td mat-cell *matCellDef="let element"><img src= "{{element.payload.doc.data().imgurl}}" height="50px" width="60px"> </td>
          </ng-container> -->
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
      
</div>